import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { css } from '@emotion/core';
import { Box, Button, Flex, FlexProps } from '@qga/roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

interface WrapperProps extends FlexProps {
  showCashAndPoints?: boolean;
}

export const Wrapper = styled(Flex)<WrapperProps>`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const DataWrapper = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  ${mediaQuery.minWidth.sm} {
    ${(props) =>
      props.showCashAndPoints &&
      css`
        align-items: flex-end;
      `};
  }
`;

export const ButtonLink = styled(Button)`
  width: 100%;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
  max-width: 196px;
  height: 46px;
  ${mediaQuery.minWidth.sm} {
    padding-y: ${themeGet('space.6')};
    padding-x: ${themeGet('space.3')};
    flex-grow: initial;
    max-width: 168px;
    min-width: 168px;
    margin-top: 6px;
  }

  &:hover {
    color: ${themeGet('colors.white')};
  }
`;

export const NightsAndGuestsWrapper = styled(Box)`
  display: inline;
  line-height: 24px;
`;
